import Select2 from '../../../src/js/shared/select2';

'use strict';
const $ = jQuery.noConflict();
$(function() {
	const providerApplication = {
		redirectUrl: '/provider-application-received/',

		init: function() {
			this.cacheDOM();
			if (!this.$blocks.length) return;
			this.initSelects();
			this.initTextareas();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$blocks = $('.js-provider-application-form');
		},

		initSelects: function() {
			$('.provider-application__form-card select[multiple]').each((i, el) => {
				const $el = $(el);
				const $placeholder = $el.find('option[value=""]').first();
				$el.attr('data-placeholder', $placeholder.text());
				$placeholder.remove();
			});

			// single selects keep their empty-value option (it's the "nothing selected"
			// state), but Select2 only reads it as a placeholder - excluding it from the
			// open dropdown list - once a data-placeholder attribute tells it to
			$('.provider-application__form-card select:not([multiple])').each((i, el) => {
				const $el = $(el);
				const $placeholder = $el.find('option[value=""]').first();
				if ($placeholder.length) $el.attr('data-placeholder', $placeholder.text());
			});

			Select2.initializeSelect2('.provider-application__form-card select:not([multiple])', {
				width: '100%',
				theme: 'default',
				dropdownCssClass: 'provider-application__select-dropdown',
			});

			Select2.initializeSelect2('.provider-application__form-card select[multiple]', {
				width: '100%',
				theme: 'default',
				closeOnSelect: false,
				dropdownCssClass: 'provider-application__select-dropdown',
			});

			this.bindSelectPlaceholderState();
		},

		bindSelectPlaceholderState: function() {
			const $selects = $('.provider-application__form-card select.select2-hidden-accessible');

			const togglePlaceholderState = (el) => {
				const val = $(el).val();
				const isEmpty = el.multiple ? !val || !val.length : !val;
				$(el).next('.select2-container').find('.select2-selection').toggleClass('is-placeholder', isEmpty);
			};

			$selects.each((i, el) => togglePlaceholderState(el));
			$selects.on('select2:select select2:unselect select2:clear change', function() {
				togglePlaceholderState(this);
			});
		},

		initTextareas: function() {
			const $textareas = $('.provider-application__form-card textarea.provider-application-form__textarea');

			const autoGrow = (el) => {
				el.style.height = 'auto';
				el.style.height = `${el.scrollHeight}px`;
			};

			$textareas.each((i, el) => autoGrow(el));
			$textareas.on('input', function() {
				autoGrow(this);
			});
		},

		bindEvents: function() {
			this.$blocks.each((i, block) => {
				const wrapper = block.querySelector('.wpcf7');
				const form = block.querySelector('.wpcf7 form');
				if (!wrapper || !form) return;
				const redirectUrl = block.dataset.redirectUrl || this.redirectUrl;
				wrapper.addEventListener('wpcf7mailsent', () => this.onMailSent(redirectUrl), false);
				this.initSubmitValidation(form);
			});
		},

		initSubmitValidation: function(form) {
			const submitBtn = form.querySelector('.wpcf7-submit');
			if (!submitBtn) return;

			const toggleSubmit = () => {
				submitBtn.disabled = !this.isFormValid(form);
			};

			// select2 updates its source <select> via jQuery's $(el).trigger('change'), which only
			// replays through jQuery-bound handlers during its synthetic bubble simulation - a native
			// form.addEventListener('change', ...) would never see it, so this has to bind via jQuery.
			$(form).on('input change select2:select select2:unselect select2:clear', toggleSubmit);
			toggleSubmit();
		},

		isFormValid: function(form) {
			let valid = true;

			// Check native type/pattern validity (email, url, tel) directly rather than via
			// form.checkValidity(), since CF7's own async schema validation (includes/js/index.js)
			// can leave stale setCustomValidity() errors on fields that are no longer empty when
			// fields are filled out of DOM order or in quick succession (e.g. browser autofill) -
			// form.checkValidity() would incorrectly stay false forever in that case.
			form.querySelectorAll('.wpcf7-form-control').forEach((field) => {
				if (field.validity.typeMismatch || field.validity.patternMismatch) valid = false;
			});

			form.querySelectorAll('.wpcf7-validates-as-required').forEach((field) => {
				if (field.type === 'checkbox' || field.type === 'radio') {
					if (!field.checked) valid = false;
				} else if (field.multiple) {
					if (!field.selectedOptions.length) valid = false;
				} else if (!field.value.trim()) {
					valid = false;
				}
			});

			return valid;
		},

		onMailSent: function(redirectUrl) {
			window.location.href = redirectUrl;
		},
	};

	providerApplication.init();
});
